// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apply-button[data-v-3b779cb6]{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
